export const VAT_RATE_FACTOR = 1.19;
export const DATE_OF_NFX_STUDIO_PROCESSING_RELEASE = new Date('2025-10-01');
export const MAX_RUNTIME_FOR_STUDIO_ZIP_DOWNLOAD_IN_FIREFOX = 60 * 60 * 4;
